export var AppDomain;
(function (AppDomain) {
    AppDomain["Hh"] = "HH";
    AppDomain["Jtb"] = "JTB";
    AppDomain["Jda"] = "JDA";
    AppDomain["Zp"] = "ZP";
})(AppDomain || (AppDomain = {}));
export var ApplicantsAvailability;
(function (ApplicantsAvailability) {
    ApplicantsAvailability["Enough"] = "ENOUGH";
    ApplicantsAvailability["NotEnough"] = "NOT_ENOUGH";
    ApplicantsAvailability["Deficit"] = "DEFICIT";
})(ApplicantsAvailability || (ApplicantsAvailability = {}));
export var AreaSearchType;
(function (AreaSearchType) {
    AreaSearchType["LivingOrRelocation"] = "LIVING_OR_RELOCATION";
    AreaSearchType["Living"] = "LIVING";
    AreaSearchType["LivingButRelocation"] = "LIVING_BUT_RELOCATION";
    AreaSearchType["Relocation"] = "RELOCATION";
})(AreaSearchType || (AreaSearchType = {}));
export var AreaType;
(function (AreaType) {
    AreaType["Other"] = "OTHER";
    AreaType["Country"] = "COUNTRY";
    AreaType["Okrug"] = "OKRUG";
    AreaType["Oblast"] = "OBLAST";
    AreaType["OblastCentre"] = "OBLAST_CENTRE";
    AreaType["RaionCentre"] = "RAION_CENTRE";
    AreaType["City"] = "CITY";
})(AreaType || (AreaType = {}));
export var ChatWritePossibility;
(function (ChatWritePossibility) {
    ChatWritePossibility["EnabledAfterInvitation"] = "ENABLED_AFTER_INVITATION";
    ChatWritePossibility["Enabled"] = "ENABLED";
    ChatWritePossibility["Disabled"] = "DISABLED";
})(ChatWritePossibility || (ChatWritePossibility = {}));
export var CompetitionLevel;
(function (CompetitionLevel) {
    CompetitionLevel["Low"] = "LOW";
    CompetitionLevel["Medium"] = "MEDIUM";
    CompetitionLevel["High"] = "HIGH";
    CompetitionLevel["Undefined"] = "UNDEFINED";
})(CompetitionLevel || (CompetitionLevel = {}));
export var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["Usd"] = "USD";
    CurrencyCode["Eur"] = "EUR";
    CurrencyCode["Rub"] = "RUB";
    CurrencyCode["Uah"] = "UAH";
    CurrencyCode["Kzt"] = "KZT";
    CurrencyCode["Byr"] = "BYR";
    CurrencyCode["Azn"] = "AZN";
    CurrencyCode["Uzs"] = "UZS";
    CurrencyCode["Gel"] = "GEL";
    CurrencyCode["Kgs"] = "KGS";
})(CurrencyCode || (CurrencyCode = {}));
export var DisplayType;
(function (DisplayType) {
    DisplayType["Desktop"] = "DESKTOP";
    DisplayType["Mobile"] = "MOBILE";
    DisplayType["Tablet"] = "TABLET";
})(DisplayType || (DisplayType = {}));
export var Distance;
(function (Distance) {
    Distance["FiveHundredMetres"] = "FIVE_HUNDRED_METRES";
    Distance["OneThousandMetres"] = "ONE_THOUSAND_METRES";
    Distance["ThreeThousandMetres"] = "THREE_THOUSAND_METRES";
    Distance["FiveThousandMetres"] = "FIVE_THOUSAND_METRES";
    Distance["TenThousandMetres"] = "TEN_THOUSAND_METRES";
    Distance["FifteenThousandMetres"] = "FIFTEEN_THOUSAND_METRES";
})(Distance || (Distance = {}));
export var DriverLicenseType;
(function (DriverLicenseType) {
    DriverLicenseType["A"] = "A";
    DriverLicenseType["B"] = "B";
    DriverLicenseType["C"] = "C";
    DriverLicenseType["D"] = "D";
    DriverLicenseType["E"] = "E";
    DriverLicenseType["BE"] = "BE";
    DriverLicenseType["CE"] = "CE";
    DriverLicenseType["DE"] = "DE";
    DriverLicenseType["TM"] = "TM";
    DriverLicenseType["TB"] = "TB";
})(DriverLicenseType || (DriverLicenseType = {}));
export var EducationLevel;
(function (EducationLevel) {
    EducationLevel["Secondary"] = "SECONDARY";
    EducationLevel["SpecialSecondary"] = "SPECIAL_SECONDARY";
    EducationLevel["UnfinishedHigher"] = "UNFINISHED_HIGHER";
    EducationLevel["Higher"] = "HIGHER";
    EducationLevel["Bachelor"] = "BACHELOR";
    EducationLevel["Master"] = "MASTER";
    EducationLevel["Candidate"] = "CANDIDATE";
    EducationLevel["Doctor"] = "DOCTOR";
})(EducationLevel || (EducationLevel = {}));
export var EmployerCategory;
(function (EmployerCategory) {
    EmployerCategory["SelfEmployed"] = "SELF_EMPLOYED";
    EmployerCategory["PrivateIndividual"] = "PRIVATE_INDIVIDUAL";
    EmployerCategory["ProjectDirector"] = "PROJECT_DIRECTOR";
    EmployerCategory["PrivateRecruiter"] = "PRIVATE_RECRUITER";
    EmployerCategory["Agency"] = "AGENCY";
    EmployerCategory["Company"] = "COMPANY";
    EmployerCategory["Unknown"] = "UNKNOWN";
})(EmployerCategory || (EmployerCategory = {}));
export var EmployerComplaintReason;
(function (EmployerComplaintReason) {
    EmployerComplaintReason["NotVacancy"] = "NOT_VACANCY";
    EmployerComplaintReason["Deceiver"] = "DECEIVER";
    EmployerComplaintReason["Offensive"] = "OFFENSIVE";
    EmployerComplaintReason["MultilevelMarketing"] = "MULTILEVEL_MARKETING";
    EmployerComplaintReason["ChargingFeesDuringEmployment"] = "CHARGING_FEES_DURING_EMPLOYMENT";
    EmployerComplaintReason["IllegalActivities"] = "ILLEGAL_ACTIVITIES";
    EmployerComplaintReason["LaborLawViolation"] = "LABOR_LAW_VIOLATION";
    EmployerComplaintReason["LiquidatedCompany"] = "LIQUIDATED_COMPANY";
})(EmployerComplaintReason || (EmployerComplaintReason = {}));
export var EmployerDiscardStatus;
(function (EmployerDiscardStatus) {
    EmployerDiscardStatus["Empty"] = "EMPTY";
    EmployerDiscardStatus["NoMcpName"] = "NO_MCP_NAME";
    EmployerDiscardStatus["NoMcpPhone"] = "NO_MCP_PHONE";
    EmployerDiscardStatus["NoCompanyDescr"] = "NO_COMPANY_DESCR";
    EmployerDiscardStatus["NoCompanyName"] = "NO_COMPANY_NAME";
    EmployerDiscardStatus["Mlm"] = "MLM";
    EmployerDiscardStatus["AlreadyRegistered"] = "ALREADY_REGISTERED";
    EmployerDiscardStatus["Delete"] = "DELETE";
    EmployerDiscardStatus["NoContact"] = "NO_CONTACT";
    EmployerDiscardStatus["NoActivity"] = "NO_ACTIVITY";
    EmployerDiscardStatus["ApplicantComplaint"] = "APPLICANT_COMPLAINT";
    EmployerDiscardStatus["ClientDecision"] = "CLIENT_DECISION";
    EmployerDiscardStatus["EmployeeNotWorkInCompany"] = "EMPLOYEE_NOT_WORK_IN_COMPANY";
    EmployerDiscardStatus["CompanyEliminated"] = "COMPANY_ELIMINATED";
    EmployerDiscardStatus["VerificationFailed"] = "VERIFICATION_FAILED";
    EmployerDiscardStatus["RegistrationApplicant"] = "REGISTRATION_APPLICANT";
    EmployerDiscardStatus["FakeCompany"] = "FAKE_COMPANY";
})(EmployerDiscardStatus || (EmployerDiscardStatus = {}));
export var EmployerState;
(function (EmployerState) {
    EmployerState["Unregistered"] = "UNREGISTERED";
    EmployerState["New"] = "NEW";
    EmployerState["Approved"] = "APPROVED";
    EmployerState["Discarded"] = "DISCARDED";
    EmployerState["Disabled"] = "DISABLED";
    EmployerState["Waiting"] = "WAITING";
    EmployerState["NotVerified"] = "NOT_VERIFIED";
})(EmployerState || (EmployerState = {}));
export var Employment;
(function (Employment) {
    Employment["Full"] = "FULL";
    Employment["Part"] = "PART";
    Employment["Project"] = "PROJECT";
    Employment["Volunteer"] = "VOLUNTEER";
    Employment["Probation"] = "PROBATION";
})(Employment || (Employment = {}));
export var EventSystemType;
(function (EventSystemType) {
    EventSystemType["AddEmployerManager"] = "ADD_EMPLOYER_MANAGER";
    EventSystemType["DeleteEmployerManager"] = "DELETE_EMPLOYER_MANAGER";
    EventSystemType["EmployerAreaChange"] = "EMPLOYER_AREA_CHANGE";
    EventSystemType["EmployerComment"] = "EMPLOYER_COMMENT";
    EventSystemType["EmployerManagerComeFrom"] = "EMPLOYER_MANAGER_COME_FROM";
    EventSystemType["EmployerManagerPasswordChange"] = "EMPLOYER_MANAGER_PASSWORD_CHANGE";
    EventSystemType["EmployerManagerRemoveTo"] = "EMPLOYER_MANAGER_REMOVE_TO";
    EventSystemType["EmployerManagerPremoderatorChanged"] = "EMPLOYER_MANAGER_PREMODERATOR_CHANGED";
    EventSystemType["EmployerRegister"] = "EMPLOYER_REGISTER";
    EventSystemType["EmployerRegisterDiscard"] = "EMPLOYER_REGISTER_DISCARD";
    EventSystemType["EmployerPreregister"] = "EMPLOYER_PREREGISTER";
    EventSystemType["EmployerUnverified"] = "EMPLOYER_UNVERIFIED";
    EventSystemType["EmployerAccept"] = "EMPLOYER_ACCEPT";
    EventSystemType["EmployerAcceptToJoblist"] = "EMPLOYER_ACCEPT_TO_JOBLIST";
    EventSystemType["EmployerAcceptLightRegistration"] = "EMPLOYER_ACCEPT_LIGHT_REGISTRATION";
    EventSystemType["SalesManagerDayOff"] = "SALES_MANAGER_DAY_OFF";
    EventSystemType["CustomerCallDocumentsCirculation"] = "CUSTOMER_CALL_DOCUMENTS_CIRCULATION";
    EventSystemType["CustomerCallTechnical"] = "CUSTOMER_CALL_TECHNICAL";
    EventSystemType["CustomerCallRecruitment"] = "CUSTOMER_CALL_RECRUITMENT";
    EventSystemType["CustomerCallCommercial"] = "CUSTOMER_CALL_COMMERCIAL";
    EventSystemType["CustomerCallOther"] = "CUSTOMER_CALL_OTHER";
    EventSystemType["SelectResumeActivate"] = "SELECT_RESUME_ACTIVATE";
    EventSystemType["EmployerTypeChange"] = "EMPLOYER_TYPE_CHANGE";
    EventSystemType["EmployerUnregister"] = "EMPLOYER_UNREGISTER";
    EventSystemType["HhManagerChange"] = "HH_MANAGER_CHANGE";
    EventSystemType["McpChange"] = "MCP_CHANGE";
    EventSystemType["PresaleObtainRequests"] = "PRESALE_OBTAIN_REQUESTS";
    EventSystemType["PresalePutoffRequests"] = "PRESALE_PUTOFF_REQUESTS";
    EventSystemType["EmailToClient"] = "EMAIL_TO_CLIENT";
    EventSystemType["EmployerSetHiddenOn"] = "EMPLOYER_SET_HIDDEN_ON";
    EventSystemType["EmployerSetHiddenOff"] = "EMPLOYER_SET_HIDDEN_OFF";
    EventSystemType["EmployerSmallMediumBusiness"] = "EMPLOYER_SMALL_MEDIUM_BUSINESS";
    EventSystemType["EmployerTabTextChange"] = "EMPLOYER_TAB_TEXT_CHANGE";
    EventSystemType["EmployerNameChange"] = "EMPLOYER_NAME_CHANGE";
    EventSystemType["EmployerOrgFormChange"] = "EMPLOYER_ORG_FORM_CHANGE";
    EventSystemType["RequestActOriginal"] = "REQUEST_ACT_ORIGINAL";
    EventSystemType["EmployerIndustriesChange"] = "EMPLOYER_INDUSTRIES_CHANGE";
    EventSystemType["EmployerCustomPageTemplateStatusChanged"] = "EMPLOYER_CUSTOM_PAGE_TEMPLATE_STATUS_CHANGED";
    EventSystemType["EmployerPermissionsChanged"] = "EMPLOYER_PERMISSIONS_CHANGED";
    EventSystemType["EmployerQuotesChanged"] = "EMPLOYER_QUOTES_CHANGED";
    EventSystemType["AgreementClose"] = "AGREEMENT_CLOSE";
    EventSystemType["AgreementCreate"] = "AGREEMENT_CREATE";
    EventSystemType["AgreementDemandFromManager"] = "AGREEMENT_DEMAND_FROM_MANAGER";
    EventSystemType["AgreementStateChange"] = "AGREEMENT_STATE_CHANGE";
    EventSystemType["BillCreate"] = "BILL_CREATE";
    EventSystemType["BillEditBank"] = "BILL_EDIT_BANK";
    EventSystemType["BillEditSum"] = "BILL_EDIT_SUM";
    EventSystemType["BillEditAgreement"] = "BILL_EDIT_AGREEMENT";
    EventSystemType["BillDiscard"] = "BILL_DISCARD";
    EventSystemType["BillPay"] = "BILL_PAY";
    EventSystemType["BillUndo"] = "BILL_UNDO";
    EventSystemType["BonusActivate"] = "BONUS_ACTIVATE";
    EventSystemType["DeedCreate"] = "DEED_CREATE";
    EventSystemType["BillMakePostpaid"] = "BILL_MAKE_POSTPAID";
    EventSystemType["DeedStateChange"] = "DEED_STATE_CHANGE";
    EventSystemType["DeedHardCopyStateChange"] = "DEED_HARD_COPY_STATE_CHANGE";
    EventSystemType["DeedStateReportSent"] = "DEED_STATE_REPORT_SENT";
    EventSystemType["DeedDeleteForce"] = "DEED_DELETE_FORCE";
    EventSystemType["DeedEdit"] = "DEED_EDIT";
    EventSystemType["DeedBankDetailChange"] = "DEED_BANK_DETAIL_CHANGE";
    EventSystemType["DeedEditNumber"] = "DEED_EDIT_NUMBER";
    EventSystemType["AdvDeedDeleteForce"] = "ADV_DEED_DELETE_FORCE";
    EventSystemType["AdministrativeAction"] = "ADMINISTRATIVE_ACTION";
    EventSystemType["DeedGrouped"] = "DEED_GROUPED";
    EventSystemType["DeedUngrouped"] = "DEED_UNGROUPED";
    EventSystemType["DeedGroupingSettingsUpdated"] = "DEED_GROUPING_SETTINGS_UPDATED";
    EventSystemType["DeedGroupingForAgreementUpdated"] = "DEED_GROUPING_FOR_AGREEMENT_UPDATED";
    EventSystemType["ServiceAdd"] = "SERVICE_ADD";
    EventSystemType["ServiceBuy"] = "SERVICE_BUY";
    EventSystemType["RequestServiceUndo"] = "REQUEST_SERVICE_UNDO";
    EventSystemType["ServiceUndo"] = "SERVICE_UNDO";
    EventSystemType["WhiteBuh"] = "WHITE_BUH";
    EventSystemType["VerificationActOriginalFailed"] = "VERIFICATION_ACT_ORIGINAL_FAILED";
    EventSystemType["ManualServiceBurn"] = "MANUAL_SERVICE_BURN";
    EventSystemType["EmployerBanOnComplaint"] = "EMPLOYER_BAN_ON_COMPLAINT";
    EventSystemType["ApplyOferta"] = "APPLY_OFERTA";
    EventSystemType["RegistrationDocumentUploadNew"] = "REGISTRATION_DOCUMENT_UPLOAD_NEW";
    EventSystemType["RegistrationDocumentUploadChanges"] = "REGISTRATION_DOCUMENT_UPLOAD_CHANGES";
    EventSystemType["ComplaintAgainstEmployer"] = "COMPLAINT_AGAINST_EMPLOYER";
    EventSystemType["AssessmentsFirstResult"] = "ASSESSMENTS_FIRST_RESULT";
    EventSystemType["AssessmentsTrialRequest"] = "ASSESSMENTS_TRIAL_REQUEST";
    EventSystemType["CustomerCallCancel"] = "CUSTOMER_CALL_CANCEL";
    EventSystemType["PolicyViolationReaction"] = "POLICY_VIOLATION_REACTION";
    EventSystemType["DocumentsDemand"] = "DOCUMENTS_DEMAND";
    EventSystemType["LockedgateBlock"] = "LOCKEDGATE_BLOCK";
    EventSystemType["MoveVacanciesToEmployerManager"] = "MOVE_VACANCIES_TO_EMPLOYER_MANAGER";
    EventSystemType["MoveFavoriteResumesFoldersToEmployerManager"] = "MOVE_FAVORITE_RESUMES_FOLDERS_TO_EMPLOYER_MANAGER";
    EventSystemType["MoveResumeSavedSearchesToEmployerManager"] = "MOVE_RESUME_SAVED_SEARCHES_TO_EMPLOYER_MANAGER";
    EventSystemType["MoveEmployerManagerItemsOnBlock"] = "MOVE_EMPLOYER_MANAGER_ITEMS_ON_BLOCK";
    EventSystemType["BillMakePaid"] = "BILL_MAKE_PAID";
    EventSystemType["EmployerSuspicious"] = "EMPLOYER_SUSPICIOUS";
    EventSystemType["EmployerNotSuspicious"] = "EMPLOYER_NOT_SUSPICIOUS";
    EventSystemType["ManagerCreationRestrictedTurnOn"] = "MANAGER_CREATION_RESTRICTED_TURN_ON";
    EventSystemType["ManagerCreationRestrictedTurnOff"] = "MANAGER_CREATION_RESTRICTED_TURN_OFF";
    EventSystemType["PersonalManagerRatedBad"] = "PERSONAL_MANAGER_RATED_BAD";
    EventSystemType["PersonalManagerRatedGood"] = "PERSONAL_MANAGER_RATED_GOOD";
    EventSystemType["PersonalManagerRatedExcellent"] = "PERSONAL_MANAGER_RATED_EXCELLENT";
    EventSystemType["EmployerManagerPhoneChange"] = "EMPLOYER_MANAGER_PHONE_CHANGE";
    EventSystemType["BlacklistedRegistration"] = "BLACKLISTED_REGISTRATION";
    EventSystemType["SuspiciousVacancyInvitation"] = "SUSPICIOUS_VACANCY_INVITATION";
    EventSystemType["EmployerRegistrationWithReducedForm"] = "EMPLOYER_REGISTRATION_WITH_REDUCED_FORM";
    EventSystemType["VacancyArchivedForReplacement"] = "VACANCY_ARCHIVED_FOR_REPLACEMENT";
    EventSystemType["EmployerRegistrationActiveExperiments"] = "EMPLOYER_REGISTRATION_ACTIVE_EXPERIMENTS";
    EventSystemType["EmployerRegistrationControlExperiments"] = "EMPLOYER_REGISTRATION_CONTROL_EXPERIMENTS";
    EventSystemType["AddEmployerCrmBlockTag"] = "ADD_EMPLOYER_CRM_BLOCK_TAG";
    EventSystemType["DeleteEmployerCrmBlockTag"] = "DELETE_EMPLOYER_CRM_BLOCK_TAG";
    EventSystemType["EmployerSecondFactorAuthEnabled"] = "EMPLOYER_SECOND_FACTOR_AUTH_ENABLED";
    EventSystemType["EmployerSecondFactorAuthDisabled"] = "EMPLOYER_SECOND_FACTOR_AUTH_DISABLED";
    EventSystemType["NewEmployerSurveyStep_1"] = "NEW_EMPLOYER_SURVEY_STEP_1";
    EventSystemType["NewEmployerSurveyStep_2"] = "NEW_EMPLOYER_SURVEY_STEP_2";
    EventSystemType["EmployerDuplicateAutoBlocked"] = "EMPLOYER_DUPLICATE_AUTO_BLOCKED";
    EventSystemType["RsBillPaid"] = "RS_BILL_PAID";
    EventSystemType["EmployerDuplicateAutoBlockedByName"] = "EMPLOYER_DUPLICATE_AUTO_BLOCKED_BY_NAME";
    EventSystemType["NeverLoggedInEmployerManagerEmailChange"] = "NEVER_LOGGED_IN_EMPLOYER_MANAGER_EMAIL_CHANGE";
    EventSystemType["ServiceTermination"] = "SERVICE_TERMINATION";
    EventSystemType["EmployerCtDisabled"] = "EMPLOYER_CT_DISABLED";
    EventSystemType["EmployerCtEnabled"] = "EMPLOYER_CT_ENABLED";
    EventSystemType["VacancyUnapproveOnComplaint"] = "VACANCY_UNAPPROVE_ON_COMPLAINT";
    EventSystemType["UntrustedEmployerNegotiationsLimitExceeded"] = "UNTRUSTED_EMPLOYER_NEGOTIATIONS_LIMIT_EXCEEDED";
    EventSystemType["VacanciesMoveTo"] = "VACANCIES_MOVE_TO";
    EventSystemType["VacanciesComeFrom"] = "VACANCIES_COME_FROM";
    EventSystemType["AdditionalEmployerVerification"] = "ADDITIONAL_EMPLOYER_VERIFICATION";
    EventSystemType["EmployerManagerEmailChange"] = "EMPLOYER_MANAGER_EMAIL_CHANGE";
    EventSystemType["EmployerManagerEmailChangeInitiated"] = "EMPLOYER_MANAGER_EMAIL_CHANGE_INITIATED";
    EventSystemType["EmailChangeRestrictionOn"] = "EMAIL_CHANGE_RESTRICTION_ON";
    EventSystemType["EmailChangeRestrictionOff"] = "EMAIL_CHANGE_RESTRICTION_OFF";
    EventSystemType["EmailChangeRestrictionForEveryoneOn"] = "EMAIL_CHANGE_RESTRICTION_FOR_EVERYONE_ON";
    EventSystemType["EmailChangeRestrictionForEveryoneOff"] = "EMAIL_CHANGE_RESTRICTION_FOR_EVERYONE_OFF";
    EventSystemType["TinkoffBusinessRegistration"] = "TINKOFF_BUSINESS_REGISTRATION";
    EventSystemType["ComplaintAboutTrustedEmployer"] = "COMPLAINT_ABOUT_TRUSTED_EMPLOYER";
    EventSystemType["RegistrationByPartner"] = "REGISTRATION_BY_PARTNER";
    EventSystemType["EmployerSellerChange"] = "EMPLOYER_SELLER_CHANGE";
    EventSystemType["BillPaidViaCurrentAccountByDifferentPayerAndEmployer"] = "BILL_PAID_VIA_CURRENT_ACCOUNT_BY_DIFFERENT_PAYER_AND_EMPLOYER";
    EventSystemType["AdditionalEmployerVerificationByVacancy"] = "ADDITIONAL_EMPLOYER_VERIFICATION_BY_VACANCY";
    EventSystemType["CrosspostVacancyZpToHh"] = "CROSSPOST_VACANCY_ZP_TO_HH";
    EventSystemType["DecrosspostVacancyZpFromHh"] = "DECROSSPOST_VACANCY_ZP_FROM_HH";
    EventSystemType["ComplaintAboutUntrustedApprovedEmployer"] = "COMPLAINT_ABOUT_UNTRUSTED_APPROVED_EMPLOYER";
    EventSystemType["EmployerTypeOfRegistrationChosen"] = "EMPLOYER_TYPE_OF_REGISTRATION_CHOSEN";
    EventSystemType["EmployerRegistrationByDigitalMarketingPartner"] = "EMPLOYER_REGISTRATION_BY_DIGITAL_MARKETING_PARTNER";
    EventSystemType["MoveVacancyToEmployerManagerOnCreation"] = "MOVE_VACANCY_TO_EMPLOYER_MANAGER_ON_CREATION";
    EventSystemType["MoveVacancyDraftsToEmployerManager"] = "MOVE_VACANCY_DRAFTS_TO_EMPLOYER_MANAGER";
    EventSystemType["ArchivingOfAllVacanciesStarted"] = "ARCHIVING_OF_ALL_VACANCIES_STARTED";
    EventSystemType["EmployerAdditionalCheckStarted"] = "EMPLOYER_ADDITIONAL_CHECK_STARTED";
    EventSystemType["EmployerAdditionalCheckStopped"] = "EMPLOYER_ADDITIONAL_CHECK_STOPPED";
    EventSystemType["ChangeVacancyAfterModerationRestricted"] = "CHANGE_VACANCY_AFTER_MODERATION_RESTRICTED";
    EventSystemType["EmployerManagerMassChange"] = "EMPLOYER_MANAGER_MASS_CHANGE";
    EventSystemType["TinkoffBusinessRegistrationAutoVerification"] = "TINKOFF_BUSINESS_REGISTRATION_AUTO_VERIFICATION";
    EventSystemType["TinkoffBusinessRegistrationManualVerification"] = "TINKOFF_BUSINESS_REGISTRATION_MANUAL_VERIFICATION";
    EventSystemType["HomeStaffTagSet"] = "HOME_STAFF_TAG_SET";
    EventSystemType["HomeStaffTagUnset"] = "HOME_STAFF_TAG_UNSET";
    EventSystemType["VacancyPremoderationEnabled"] = "VACANCY_PREMODERATION_ENABLED";
    EventSystemType["VacancyPremoderationDisabled"] = "VACANCY_PREMODERATION_DISABLED";
    EventSystemType["EmployerTaxNumber"] = "EMPLOYER_TAX_NUMBER";
    EventSystemType["EmployerResumeViewLimitChanged"] = "EMPLOYER_RESUME_VIEW_LIMIT_CHANGED";
    EventSystemType["ManagerResumeViewLimitChanged"] = "MANAGER_RESUME_VIEW_LIMIT_CHANGED";
    EventSystemType["EmployerDivisionFeatureEnabled"] = "EMPLOYER_DIVISION_FEATURE_ENABLED";
    EventSystemType["EmployerDivisionFeatureDisabled"] = "EMPLOYER_DIVISION_FEATURE_DISABLED";
    EventSystemType["EmployerDivisionWritePermissionGranted"] = "EMPLOYER_DIVISION_WRITE_PERMISSION_GRANTED";
    EventSystemType["EmployerDivisionWritePermissionRevoked"] = "EMPLOYER_DIVISION_WRITE_PERMISSION_REVOKED";
    EventSystemType["EmployerReviewsVisibilityChange"] = "EMPLOYER_REVIEWS_VISIBILITY_CHANGE";
    EventSystemType["EmployerAuthVerifyExp"] = "EMPLOYER_AUTH_VERIFY_EXP";
})(EventSystemType || (EventSystemType = {}));
export var Gender;
(function (Gender) {
    Gender["Male"] = "MALE";
    Gender["Female"] = "FEMALE";
    Gender["Unknown"] = "UNKNOWN";
})(Gender || (Gender = {}));
export var Lang;
(function (Lang) {
    Lang["Ru"] = "RU";
    Lang["En"] = "EN";
    Lang["Az"] = "AZ";
    Lang["Kz"] = "KZ";
    Lang["Ua"] = "UA";
    Lang["Uz"] = "UZ";
    Lang["Kg"] = "KG";
})(Lang || (Lang = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["Ru"] = "RU";
    LanguageCode["En"] = "EN";
    LanguageCode["Fr"] = "FR";
    LanguageCode["It"] = "IT";
    LanguageCode["De"] = "DE";
})(LanguageCode || (LanguageCode = {}));
export var LanguageLevel;
(function (LanguageLevel) {
    LanguageLevel["A1"] = "a1";
    LanguageLevel["A2"] = "a2";
    LanguageLevel["B1"] = "b1";
    LanguageLevel["B2"] = "b2";
    LanguageLevel["C1"] = "c1";
    LanguageLevel["C2"] = "c2";
    LanguageLevel["L1"] = "l1";
})(LanguageLevel || (LanguageLevel = {}));
export var OperatingSystem;
(function (OperatingSystem) {
    OperatingSystem["Windows"] = "WINDOWS";
    OperatingSystem["Macos"] = "MACOS";
    OperatingSystem["Linux"] = "LINUX";
    OperatingSystem["Ios"] = "IOS";
    OperatingSystem["Android"] = "ANDROID";
})(OperatingSystem || (OperatingSystem = {}));
export var PaymentServiceType;
(function (PaymentServiceType) {
    PaymentServiceType["ResumeTargetEmployer"] = "RESUME_TARGET_EMPLOYER";
    PaymentServiceType["ResumeTargetAgencies"] = "RESUME_TARGET_AGENCIES";
    PaymentServiceType["ResumeMark"] = "RESUME_MARK";
    PaymentServiceType["ResumeRenewal"] = "RESUME_RENEWAL";
    PaymentServiceType["FastVacancies"] = "FAST_VACANCIES";
    PaymentServiceType["CareerGuidance"] = "CAREER_GUIDANCE";
    PaymentServiceType["CareerVector"] = "CAREER_VECTOR";
    PaymentServiceType["CompleteResume"] = "COMPLETE_RESUME";
    PaymentServiceType["CompleteResumeBase"] = "COMPLETE_RESUME_BASE";
    PaymentServiceType["CompleteResumeOptimal"] = "COMPLETE_RESUME_OPTIMAL";
    PaymentServiceType["CompleteResumeMaximal"] = "COMPLETE_RESUME_MAXIMAL";
    PaymentServiceType["CompleteResumeConsultOnly"] = "COMPLETE_RESUME_CONSULT_ONLY";
    PaymentServiceType["CompleteResumeInterviewPractice"] = "COMPLETE_RESUME_INTERVIEW_PRACTICE";
    PaymentServiceType["ResumeAudit"] = "RESUME_AUDIT";
    PaymentServiceType["HhAcademy"] = "HH_ACADEMY";
    PaymentServiceType["ResumeFastVacancies"] = "RESUME_FAST_VACANCIES";
    PaymentServiceType["CareerMarathonBase"] = "CAREER_MARATHON_BASE";
    PaymentServiceType["CareerMarathonOptimal"] = "CAREER_MARATHON_OPTIMAL";
    PaymentServiceType["CareerMarathonMaximal"] = "CAREER_MARATHON_MAXIMAL";
    PaymentServiceType["VacancyResponsesSummary"] = "VACANCY_RESPONSES_SUMMARY";
    PaymentServiceType["HhProSubscription"] = "HH_PRO_SUBSCRIPTION";
})(PaymentServiceType || (PaymentServiceType = {}));
export var Platform;
(function (Platform) {
    Platform["Xhh"] = "XHH";
    Platform["Mhh"] = "MHH";
    Platform["Api"] = "API";
    Platform["Ios"] = "IOS";
    Platform["Android"] = "ANDROID";
    Platform["Talantix"] = "TALANTIX";
    Platform["Justai"] = "JUSTAI";
    Platform["Winphone"] = "WINPHONE";
    Platform["Mailing"] = "MAILING";
    Platform["Bots"] = "BOTS";
    Platform["VkMiniapp"] = "VK_MINIAPP";
})(Platform || (Platform = {}));
export var Relocation;
(function (Relocation) {
    Relocation["NoRelocation"] = "NO_RELOCATION";
    Relocation["RelocationPossible"] = "RELOCATION_POSSIBLE";
    Relocation["RelocationDesirable"] = "RELOCATION_DESIRABLE";
})(Relocation || (Relocation = {}));
export var ResumeEmployment;
(function (ResumeEmployment) {
    ResumeEmployment["Full"] = "FULL";
    ResumeEmployment["Part"] = "PART";
    ResumeEmployment["Project"] = "PROJECT";
    ResumeEmployment["Volunteer"] = "VOLUNTEER";
    ResumeEmployment["Probation"] = "PROBATION";
})(ResumeEmployment || (ResumeEmployment = {}));
export var ResumeStatus;
(function (ResumeStatus) {
    ResumeStatus["Approved"] = "APPROVED";
    ResumeStatus["Blocked"] = "BLOCKED";
    ResumeStatus["Corrected"] = "CORRECTED";
    ResumeStatus["Deleted"] = "DELETED";
    ResumeStatus["Modified"] = "MODIFIED";
    ResumeStatus["New"] = "NEW";
    ResumeStatus["NotFinished"] = "NOT_FINISHED";
    ResumeStatus["UserDeleted"] = "USER_DELETED";
    ResumeStatus["AutoApproved"] = "AUTO_APPROVED";
})(ResumeStatus || (ResumeStatus = {}));
export var RoadTimeType;
(function (RoadTimeType) {
    RoadTimeType["Any"] = "ANY";
    RoadTimeType["LessThanHour"] = "LESS_THAN_HOUR";
    RoadTimeType["FromHourToOneAndHalf"] = "FROM_HOUR_TO_ONE_AND_HALF";
})(RoadTimeType || (RoadTimeType = {}));
export var SalaryRange;
(function (SalaryRange) {
    SalaryRange["NotSpecified"] = "NOT_SPECIFIED";
    SalaryRange["Undefined"] = "UNDEFINED";
    SalaryRange["TooWide"] = "TOO_WIDE";
    SalaryRange["TooLow"] = "TOO_LOW";
    SalaryRange["Low"] = "LOW";
    SalaryRange["MatchMarket"] = "MATCH_MARKET";
    SalaryRange["High"] = "HIGH";
    SalaryRange["TooHigh"] = "TOO_HIGH";
})(SalaryRange || (SalaryRange = {}));
export var SharedTag;
(function (SharedTag) {
    SharedTag["YouthCvUserUnder_23WithLessYearExperience"] = "YOUTH_CV_USER_UNDER_23_WITH_LESS_YEAR_EXPERIENCE";
    SharedTag["ItApplicantByProfRole"] = "IT_APPLICANT_BY_PROF_ROLE";
})(SharedTag || (SharedTag = {}));
export var SharedTagEntityType;
(function (SharedTagEntityType) {
    SharedTagEntityType["Hhid"] = "HHID";
    SharedTagEntityType["Hhuid"] = "HHUID";
    SharedTagEntityType["ManagerId"] = "MANAGER_ID";
    SharedTagEntityType["EmployerId"] = "EMPLOYER_ID";
    SharedTagEntityType["ResumeId"] = "RESUME_ID";
    SharedTagEntityType["VacancyId"] = "VACANCY_ID";
})(SharedTagEntityType || (SharedTagEntityType = {}));
export var UserPlatform;
(function (UserPlatform) {
    UserPlatform["DesktopWeb"] = "DESKTOP_WEB";
    UserPlatform["MobileWeb"] = "MOBILE_WEB";
    UserPlatform["Api"] = "API";
    UserPlatform["Ios"] = "IOS";
    UserPlatform["Android"] = "ANDROID";
    UserPlatform["Talantix"] = "TALANTIX";
    UserPlatform["Justai"] = "JUSTAI";
    UserPlatform["Winphone"] = "WINPHONE";
    UserPlatform["Mailing"] = "MAILING";
    UserPlatform["Bots"] = "BOTS";
    UserPlatform["VkMiniapp"] = "VK_MINIAPP";
    UserPlatform["ZpDesktopWeb"] = "ZP_DESKTOP_WEB";
    UserPlatform["ZpMobileWeb"] = "ZP_MOBILE_WEB";
    UserPlatform["ZpApi"] = "ZP_API";
    UserPlatform["ZpIos"] = "ZP_IOS";
    UserPlatform["ZpAndroid"] = "ZP_ANDROID";
})(UserPlatform || (UserPlatform = {}));
export var VacancyPlatform;
(function (VacancyPlatform) {
    VacancyPlatform["Hh"] = "HH";
    VacancyPlatform["Zp"] = "ZP";
})(VacancyPlatform || (VacancyPlatform = {}));
export var WorkExperience;
(function (WorkExperience) {
    WorkExperience["NoWorkExperience"] = "NO_WORK_EXPERIENCE";
    WorkExperience["WorkExperienceFrom_1YearTo_3Year"] = "WORK_EXPERIENCE_FROM_1_YEAR_TO_3_YEAR";
    WorkExperience["WorkExperienceFrom_3YearTo_6Year"] = "WORK_EXPERIENCE_FROM_3_YEAR_TO_6_YEAR";
    WorkExperience["WorkExperienceMoreThan_6Year"] = "WORK_EXPERIENCE_MORE_THAN_6_YEAR";
})(WorkExperience || (WorkExperience = {}));
export var WorkSchedule;
(function (WorkSchedule) {
    WorkSchedule["FullDay"] = "FULL_DAY";
    WorkSchedule["Shift"] = "SHIFT";
    WorkSchedule["Flexible"] = "FLEXIBLE";
    WorkSchedule["Remote"] = "REMOTE";
    WorkSchedule["FlyInFlyOut"] = "FLY_IN_FLY_OUT";
})(WorkSchedule || (WorkSchedule = {}));
export var WorkingDay;
(function (WorkingDay) {
    WorkingDay["OnlySaturdayAndSunday"] = "ONLY_SATURDAY_AND_SUNDAY";
})(WorkingDay || (WorkingDay = {}));
export var WorkingTimeInterval;
(function (WorkingTimeInterval) {
    WorkingTimeInterval["FromFourToSixHoursInADay"] = "FROM_FOUR_TO_SIX_HOURS_IN_A_DAY";
})(WorkingTimeInterval || (WorkingTimeInterval = {}));
export var WorkingTimeMode;
(function (WorkingTimeMode) {
    WorkingTimeMode["StartAfterSixteen"] = "START_AFTER_SIXTEEN";
})(WorkingTimeMode || (WorkingTimeMode = {}));
export var CompensationFrequency;
(function (CompensationFrequency) {
    CompensationFrequency["Daily"] = "DAILY";
    CompensationFrequency["Weekly"] = "WEEKLY";
    CompensationFrequency["TwicePerMonth"] = "TWICE_PER_MONTH";
    CompensationFrequency["Monthly"] = "MONTHLY";
    CompensationFrequency["PerProject"] = "PER_PROJECT";
})(CompensationFrequency || (CompensationFrequency = {}));
export var CompensationMode;
(function (CompensationMode) {
    CompensationMode["Month"] = "MONTH";
    CompensationMode["Shift"] = "SHIFT";
    CompensationMode["Hour"] = "HOUR";
    CompensationMode["FlyInFlyOut"] = "FLY_IN_FLY_OUT";
    CompensationMode["Service"] = "SERVICE";
})(CompensationMode || (CompensationMode = {}));
export var EmploymentForm;
(function (EmploymentForm) {
    EmploymentForm["Full"] = "FULL";
    EmploymentForm["Part"] = "PART";
    EmploymentForm["Project"] = "PROJECT";
    EmploymentForm["FlyInFlyOut"] = "FLY_IN_FLY_OUT";
})(EmploymentForm || (EmploymentForm = {}));
export var FlyInFlyOutDuration;
(function (FlyInFlyOutDuration) {
    FlyInFlyOutDuration["Days_15"] = "DAYS_15";
    FlyInFlyOutDuration["Days_20"] = "DAYS_20";
    FlyInFlyOutDuration["Days_30"] = "DAYS_30";
    FlyInFlyOutDuration["Days_40"] = "DAYS_40";
    FlyInFlyOutDuration["Days_45"] = "DAYS_45";
    FlyInFlyOutDuration["Days_60"] = "DAYS_60";
    FlyInFlyOutDuration["Days_90"] = "DAYS_90";
    FlyInFlyOutDuration["Days_120"] = "DAYS_120";
    FlyInFlyOutDuration["Days_180"] = "DAYS_180";
    FlyInFlyOutDuration["Other"] = "OTHER";
})(FlyInFlyOutDuration || (FlyInFlyOutDuration = {}));
export var WorkFormat;
(function (WorkFormat) {
    WorkFormat["OnSite"] = "ON_SITE";
    WorkFormat["Remote"] = "REMOTE";
    WorkFormat["Hybrid"] = "HYBRID";
    WorkFormat["FieldWork"] = "FIELD_WORK";
})(WorkFormat || (WorkFormat = {}));
export var WorkScheduleByDays;
(function (WorkScheduleByDays) {
    WorkScheduleByDays["SixOnOneOff"] = "SIX_ON_ONE_OFF";
    WorkScheduleByDays["FiveOnTwoOff"] = "FIVE_ON_TWO_OFF";
    WorkScheduleByDays["FourOnThreeOff"] = "FOUR_ON_THREE_OFF";
    WorkScheduleByDays["FourOnTwoOff"] = "FOUR_ON_TWO_OFF";
    WorkScheduleByDays["ThreeOnThreeOff"] = "THREE_ON_THREE_OFF";
    WorkScheduleByDays["ThreeOnTwoOff"] = "THREE_ON_TWO_OFF";
    WorkScheduleByDays["TwoOnTwoOff"] = "TWO_ON_TWO_OFF";
    WorkScheduleByDays["TwoOnOneOff"] = "TWO_ON_ONE_OFF";
    WorkScheduleByDays["OneOnThreeOff"] = "ONE_ON_THREE_OFF";
    WorkScheduleByDays["OneOnTwoOff"] = "ONE_ON_TWO_OFF";
    WorkScheduleByDays["Weekend"] = "WEEKEND";
    WorkScheduleByDays["Flexible"] = "FLEXIBLE";
    WorkScheduleByDays["Other"] = "OTHER";
})(WorkScheduleByDays || (WorkScheduleByDays = {}));
export var WorkingHours;
(function (WorkingHours) {
    WorkingHours["Hours_2"] = "HOURS_2";
    WorkingHours["Hours_3"] = "HOURS_3";
    WorkingHours["Hours_4"] = "HOURS_4";
    WorkingHours["Hours_5"] = "HOURS_5";
    WorkingHours["Hours_6"] = "HOURS_6";
    WorkingHours["Hours_7"] = "HOURS_7";
    WorkingHours["Hours_8"] = "HOURS_8";
    WorkingHours["Hours_9"] = "HOURS_9";
    WorkingHours["Hours_10"] = "HOURS_10";
    WorkingHours["Hours_11"] = "HOURS_11";
    WorkingHours["Hours_12"] = "HOURS_12";
    WorkingHours["Hours_24"] = "HOURS_24";
    WorkingHours["Flexible"] = "FLEXIBLE";
    WorkingHours["Other"] = "OTHER";
})(WorkingHours || (WorkingHours = {}));
